// extracted by mini-css-extract-plugin
export default {"loader":"loader__loader__BTCtw"};